const { createContext } = require('react')

const CarouselElementContext = createContext(null)

export default CarouselElementContext
